<template>
  <v-btn
    color="secondary"
    small
    @click="togglePanels"
  >
    <template v-if="value.length > 0">
      <v-icon>expand_less</v-icon>
      Затвори всички
    </template>
    <template v-else>
      <v-icon>expand_more</v-icon>
      Отвори всички
    </template>
  </v-btn>
</template>

<script>
export default {
  name: 'ExpandToggle',
  props: {
    value: Array,
    panels: Array,
  },
  methods: {
    togglePanels () {
      if (this.value.length > 0) {
        this.$emit('input', [])
      } else {
        this.$emit('input', this.panels)
      }
    }
  }
}
</script>
